import { MinusCircleOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Input, Modal, Row, Table } from 'antd';
import { useFormik } from 'formik';
import moment from 'moment';
import React, { useEffect } from 'react';
import * as yup from 'yup';
import { car_columns } from './TripTables';

const carsValidation = yup.object().shape({
  car_rentals: yup.array().of(yup.object().shape({
    duration_from: yup.string().required("Pick Up is required"),
    duration_to: yup.string().required("Drop Off is required"),
    city: yup.string().required("City is required"),
    description: yup.string().required("Description is required"),
  }))
})

const CarRentals = ({ tripForm, isModalVisible, setIsModalVisible }) => {
  const { car_rentals = [] } = tripForm?.values;
  const carFormik = useFormik({
    initialValues: {
      car_rentals: [{
        duration_from: "",
        duration_to: "",
        city: "",
        description: ""
      }],
    },
    validationSchema: carsValidation,
    onSubmit: (vals) => {
      tripForm.setFieldValue("car_rentals", [...vals.car_rentals])
      handleModalCancelButton()
    }
  })
  const handleModalCancelButton = () => {
    carFormik.resetForm()
    setIsModalVisible(false)
  }

  useEffect(() => {
    if (isModalVisible)
      carFormik.setFieldValue(
        'car_rentals', car_rentals?.length === 0 ? [{
          duration_from: "",
          duration_to: "",
          city: "",
          description: ""
        }] : car_rentals
      )
    // eslint-disable-next-line
  }, [isModalVisible])

  const onNewRowChange = (type, idx) => {
    if (type === "remove") {
      if (idx > -1) {
        let trips = carFormik.values.car_rentals
        trips.splice(idx, 1)
        carFormik.setFieldValue("car_rentals", trips)
      }
    } else {
      let hr = carFormik.values.car_rentals;
      hr = [...hr, {
        city: "",
        duration_from: "",
        duration_to: "",
        description: ""
      }]
      carFormik.setFieldValue("car_rentals", hr)
    }
  }

  const renderCarForm = () => <form
    onSubmit={carFormik.handleSubmit}
    className="modal-form"
  >
    <div className="trips-detail detail-card p1">
      {carFormik.values?.car_rentals.map((item, index) => (
        <Row className='mt1' key={`hotelrows_${index}`}>
          <Col span={5}>
            <Form.Item label={<>City<span className="required-star">*</span></>}
            >
              <Input placeholder="Enter"
                name={`city_key${index}`}
                value={carFormik.values?.car_rentals[index]?.city}
                onChange={(e) => {
                  let fr = carFormik.values?.car_rentals;
                  fr[index].city = e.target.value
                  carFormik.setFieldValue("car_rentals", fr)
                }}
              />
              {carFormik.touched.car_rentals?.[index]?.city && carFormik.errors.car_rentals?.[index]?.city && <div className='errorMsg'>
                {carFormik.errors.car_rentals?.[index]?.city}
              </div>}
            </Form.Item>
          </Col>
          <Col span={5} className="ml1">
            <Form.Item label={<>Pick Up<span className="required-star">*</span></>}
            >
              <DatePicker format={'DD/MM/YYYY HH:mm:ss a'} showTime
                name={`hot_duration_from_key${index}`}
                value={
                  carFormik.values?.car_rentals[index]?.duration_from ?
                    moment(carFormik.values?.car_rentals[index]?.duration_from, 'DD/MM/YYYY HH:mm:ss a') :
                    undefined}
                onChange={(date) => {
                  let fr = carFormik.values?.car_rentals;
                  fr[index].duration_from = date ? moment(date).format('DD/MM/YYYY HH:mm:ss a') : ""
                  fr[index].duration_to = ""
                  carFormik.setFieldValue("car_rentals", fr)
                }}
              />
              {carFormik.touched.car_rentals?.[index]?.duration_from && carFormik.errors.car_rentals?.[index]?.duration_from && <div className='errorMsg'>
                {carFormik.errors.car_rentals?.[index]?.duration_from}
              </div>}
            </Form.Item>
          </Col>
          <Col span={5} className="ml1">
            <Form.Item label={<>Drop Off<span className="required-star">*</span></>}
            >
              <DatePicker format={'DD/MM/YYYY HH:mm:ss a'} showTime
                name={`hot_duration_to_key${index}`}
                showNow={
                  !moment(
                    carFormik.values?.car_rentals[index]?.duration_from,
                    "DD/MM/YYYY HH:mm:ss a"
                  ).isAfter(moment())  // hide "Now" if Pick Up (from) is in the future
                }
                onChange={(date) => {
                  let fr = carFormik.values?.car_rentals;
                  fr[index].duration_to = date ? moment(date).format('DD/MM/YYYY HH:mm:ss a') : ""
                  carFormik.setFieldValue("car_rentals", fr)
                }}
                value={
                  carFormik.values?.car_rentals[index]?.duration_to ?
                    moment(carFormik.values?.car_rentals[index]?.duration_to, 'DD/MM/YYYY HH:mm:ss a') :
                    undefined}
                disabledDate={(current) => {
                  let customDate = moment(carFormik.values?.car_rentals[index]?.duration_from, 'DD/MM/YYYY HH:mm:ss a');
                  return current && current < moment(customDate);
                }}
              />
              {carFormik.touched.car_rentals?.[index]?.duration_to && carFormik.errors.car_rentals?.[index]?.duration_to && <div className='errorMsg'>
                {carFormik.errors.car_rentals?.[index]?.duration_to}
              </div>}
            </Form.Item>
          </Col>
          <Col span={5} className="ml1">
            <Form.Item label={<>Description<span className="required-star">*</span></>} >
              <Input.TextArea
                placeholder="Enter Description"
                autoSize={{ minRows: 1, maxRows: 5 }}
                maxLength={250}
                name={`hot_description_key${index}`}
                value={carFormik.values?.car_rentals?.[index]?.description}
                onChange={(e) => {
                  let fr = carFormik.values?.car_rentals;
                  fr[index].description = e.target.value
                  carFormik.setFieldValue("car_rentals", fr)
                }}
              />
              {carFormik.touched.car_rentals?.[index]?.description && carFormik.errors.car_rentals?.[index]?.description && <div className='errorMsg'>
                {carFormik.errors.car_rentals?.[index]?.description}
              </div>}
            </Form.Item>
          </Col>
          <Col span={1}>
            {index >= 1 ?
              <MinusCircleOutlined className='mt3' onClick={() => onNewRowChange('remove', index)} /> : null}
          </Col>
        </Row>
      ))}
      {car_rentals.length <= 5 ? <>
        <hr />
        <div className='p1 cursor' onClick={() => onNewRowChange('add')}> + Add another line</div>
      </> : null
      }
    </div>

    <div className='mb3 mt1'>
      <Button key="2" htmlType="button" className="cancelButton ml1 mt3 floatRight" onClick={() => handleModalCancelButton()}>Cancel</Button>
      <Button key="1" htmlType="submit" className="formButton mt3 primaryButton floatRight"
      >Save</Button>
    </div>
  </form>
  return (
    <>
      <Modal
        title={"Add Car Rental Details"}
        visible={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
        }}
        footer={[]}
        className="center-aligned-modal-big"
      >
        {renderCarForm()}
      </Modal>
      <div className="trips-detail detail-card mb2">
        <div className='mt1'>
          <Button
            className="primary-btn floatRight mr1"
            onClick={() => {
              setIsModalVisible(true);
            }}
          >
            {car_rentals?.length ? 'Edit' : `Add Car Details`}
          </Button>
        </div>
        <Table
          rowKey="id"
          columns={car_columns}
          dataSource={car_rentals?.length ? car_rentals : []}
          className="settingsTable tripsTable"
          pagination={false}
        />
      </div>
    </>
  )
};

export default CarRentals;